<template>
  <v-flex xs12 :md3="!fullscreen" class="pa-6">
    <v-card @click="$router.push('/purchases-view/'+purchase._id)" elevation="24">
      <v-system-bar lights-out></v-system-bar>
      <v-carousel
        :continuous="false"
        :cycle="true"
        :show-arrows="true"
        delimiter-icon="mdi-minus"
        height="250"
      >
        <v-carousel-item v-for="(slide, i) in purchase.item.images" :key="i">
          <v-sheet height="100%" tile>
            <v-row class="fill-height" align="center" justify="center">
              <div class="display-3">
                <v-img max-height="260" contain :src="slide"></v-img>
              </div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
      <v-list class="pa-0 ma-0" dense>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="fonte" style="font-size: 14pt;"
              >Plano de Ativação</v-list-item-title
            >
            <v-list-item-subtitle class="fonte font-weight-thin orange--text">{{
              purchase.item.description
            }}</v-list-item-subtitle>
            <v-list-item-subtitle class="green white--text px-1 "> Paga {{ purchase.item.token_earn }} MB tokens </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <v-btn
              v-if="!priceless"
              class="mt-3"
              :color="$theme.primary"
              outlined
              dark
            >
              <span class="fonte">$ {{ purchase.item.price }}</span>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item>
            <span class="text-center fonte orange--text">
                STATUS: {{ purchase.current_status }}
            </span>
        </v-list-item>
          <!-- <v-divider :key="i"></v-divider>
          <h3 class="fonte text-center my-2">BENEFÍCIOS</h3>
          <v-divider :key="i"></v-divider>
          <template v-for="(item, i) in purchase.item.system_actions">
            <v-list-item :key="item">
              <v-list-item-content>
                <h5 class="fonte text-center orange--text">{{ item.description }}</h5>
              </v-list-item-content>
              <v-list-item-actions>
                <v-icon size="15" color="green">mdi-check</v-icon>
              </v-list-item-actions>
            </v-list-item>
            <v-divider :key="i"></v-divider>
          </template> -->
      </v-list>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      teste_actions: ['teste', 'teste3', 'teste4']
    }
  },
  props: ["purchase", "fullscreen", "priceless"],
  methods: {
    ...mapActions(["viewPurchase"])
  }
};
</script>
